import { render, staticRenderFns } from "./BrandList.html?vue&type=template&id=80b386f0&scoped=true&"
import script from "./BrandList.vue?vue&type=script&lang=js&"
export * from "./BrandList.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./BrandList.vue?vue&type=style&index=1&id=80b386f0&scoped=true&lang=css&"
import style2 from "./BrandList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b386f0",
  null
  
)

export default component.exports